import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import {UpdateCfiRoutingType} from "../types/UpdateCfiRoutingType";
import {ApiResult} from "../../../../types/ApiResult";

export const useUpdateCfiRoutingMutation = (data: UpdateCfiRoutingType,
									onSuccess: () => void,
									onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("cfi-routing",
				data) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when submitting invoice: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
